import { deleteResource, get, postWithResponse } from './AuthClient';
import { CustomPattern, PatternResponse } from './dto/VLRATypes';

export const getFileNameTestResult = (filename: string, tenant?: string): Promise<string> => 
  postWithResponse<any, string>(`${process.env.REACT_APP_VLRA_SERVICE_URL}/v1/testFileName`, {
    filename,
    tenant,
  });

export const getAllPatterns = (tenant: string): Promise<PatternResponse> => 
  get<PatternResponse>(`${process.env.REACT_APP_VLRA_SERVICE_URL}/v1/patterns?tenant=${tenant}`);

export const saveCustomPattern = (customPattern: CustomPattern): Promise<void> => 
  postWithResponse<any, void>(`${process.env.REACT_APP_VLRA_SERVICE_URL}/v1/custom-patterns?tenant=${customPattern.tenant}`, customPattern);

export const deleteCustomPattern = (customPattern: CustomPattern): Promise<void> => 
  deleteResource(`${process.env.REACT_APP_VLRA_SERVICE_URL}/v1/custom-patterns?tenant=${customPattern.tenant}&patternId=${customPattern.id}`);